import React from 'react';
import { TransitionSeries } from '@remotion/transitions';

type TransitionProps = Parameters<typeof TransitionSeries.Transition>[0];

// TypeScript < 5.1 rejects JSX components whose declared return type is
// React.ReactNode (TS2786). Remotion 4 types TransitionSeries.Transition that
// way, so re-type it here until the project's TypeScript is upgraded.
export const Transition = TransitionSeries.Transition as unknown as React.FC<TransitionProps>;
